// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1__d140fe3bdeb65ac76bda","cls2":"buttonStyles-cls2___07f709d68d1bc127826 buttonStyles-cls1__d140fe3bdeb65ac76bda"};